import { buildSirvUrl } from '../service/sirv-cdn-helper';

/**
 * <img> wrapper that routes through the Sirv CDN helper and falls back to the
 * original src on load error. Pass `width` (display width in CSS pixels) so the
 * helper can request a right-sized variant.
 */
export default function OptimizedImg({ src, width, quality, format, ...rest }) {
    return (
        <img
            src={buildSirvUrl(src, { width, quality, format })}
            data-fallback-src={src}
            onError={(e) => {
                if (!e.target.dataset.fallback) {
                    e.target.dataset.fallback = '1';
                    e.target.src = e.target.dataset.fallbackSrc;
                }
            }}
            {...rest}
        />
    );
}
